import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const blurredVisionOrOpticNeuritis: AnswerPathTreeNode = {
  path: 'blurredVisionOrOpticNeuritis',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredBlurredVisionOrOpticNeuritisDetails }],
};
